import { download } from '../actions/actionTypes';
export const initialState = {};
export default function (state = initialState, action) {
    switch (action.type) {
        case download.HEIC_PROCESSING:
            const { uriKey: processingUriKey } = action.payload;
            return { ...state, [processingUriKey]: true };
        case download.HEIC_PROCESSING_DONE:
            const { uriKey: doneUriKey } = action.payload;
            const newState = { ...state };
            delete newState[doneUriKey];
            return newState;
        default:
            return state;
    }
}
